/** Título de campanita al reasignar un prospecto (api-rh). */
export const TITULO_REASIGNACION_PROSPECTO = 'Prospecto reasignado'
export const ACCION_REASIGNACION_PROSPECTO = 'reasignacion-prospecto'
export const TIPO_SOCKET_REASIGNACION = 'reasignacion-prospecto'

export function esNotificacionReasignacion (noti) {
  return String((noti && noti.titulo) || '') === TITULO_REASIGNACION_PROSPECTO
}

/**
 * Extrae deep-link desde marker `[[reasig|escuela=1|folio=X|idprospectos=Y|tel=Z]]`
 * al final del mensaje de campanita.
 */
export function parseReasignacionDesdeMensaje (mensaje) {
  const raw = String(mensaje || '')
  const m = raw.match(/\[\[reasig\|([^\]]+)\]\]/)
  if (!m) return null
  const parts = {}
  String(m[1]).split('|').forEach((pair) => {
    const idx = pair.indexOf('=')
    if (idx < 0) return
    const k = pair.slice(0, idx)
    const v = pair.slice(idx + 1)
    parts[k] = v
  })
  let folio = ''
  try {
    folio = decodeURIComponent(parts.folio || '')
  } catch (e) {
    folio = parts.folio || ''
  }
  const idprospectos = Number(parts.idprospectos) || 0
  const telefono = String(parts.tel || '').replace(/\D/g, '').slice(-10)
  const escuela = Number(parts.escuela) || 1
  if (!folio && !idprospectos && !telefono) return null
  return {
    accion: ACCION_REASIGNACION_PROSPECTO,
    folio,
    telefono,
    twilio: '',
    idprospectos,
    escuela,
  }
}

/** Texto visible en campanita (sin marker). */
export function mensajeReasignacionVisible (mensaje) {
  return String(mensaje || '').replace(/\s*\[\[reasig\|[^\]]+\]\]\s*/g, '').trim()
}

/**
 * Normaliza payload del socket notificacion-para (tipo reasignacion-prospecto).
 * Si el tipo/acción coincide, siempre regresa payload (aunque falte folio) para
 * no caer al toast genérico que imprime [object Object].
 */
export function parseReasignacionSocketPayload (msj) {
  if (!msj || typeof msj !== 'object') return null
  if (msj.tipo !== TIPO_SOCKET_REASIGNACION && msj.accion !== ACCION_REASIGNACION_PROSPECTO) {
    return null
  }
  const folio = msj.folio != null ? String(msj.folio).trim() : ''
  const telefono = msj.telefono != null
    ? String(msj.telefono).replace(/\D/g, '').slice(-10)
    : ''
  const idprospectos = msj.idprospectos != null ? Number(msj.idprospectos) : 0
  const escuela = msj.escuela != null ? Number(msj.escuela) : 1
  return {
    accion: ACCION_REASIGNACION_PROSPECTO,
    folio,
    telefono,
    twilio: msj.twilio != null ? String(msj.twilio) : '',
    idprospectos: idprospectos || 0,
    escuela: escuela || 1,
    mensaje: msj.mensaje || 'Te asignaron un contacto. Clic para abrir.',
    total: msj.total != null ? Number(msj.total) : 1,
  }
}

/** Clave estable para deduplicar toasts (varios sockets / doble emit del API). */
export function claveToastReasignacion (payload) {
  if (!payload) return ''
  return [
    'reasig',
    payload.escuela || 1,
    payload.idprospectos || 0,
    payload.folio || '',
    payload.telefono || '',
  ].join('|')
}
